import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import {
    adminNavigation,
    studentNavigation,
    compactNavigation,
    defaultNavigation,
    futuristicNavigation,
    horizontalNavigation,
} from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';
import { UserService } from 'app/core/user/user.service';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    private readonly _compactNavigation: FuseNavigationItem[] =
        compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] =
        defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] =
        futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] =
        horizontalNavigation;
    private readonly _adminNavigation: FuseNavigationItem[] =
        adminNavigation;
    private readonly _studentNavigation: FuseNavigationItem[] =
        studentNavigation;

    /**
     * Constructor
     */
    constructor(
        private _fuseMockApiService: FuseMockApiService,
        private _userService: UserService
    ) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService.onGet('api/common/navigation').reply(
            () => {
            // Get current user role
            const user = this._userService.currentUser;
            let roleBasedNavigation: FuseNavigationItem[] = [];

            // Determinar la navegación basada en el rol
            if (user && user.activeProfile) {
                // Verificar el tipo de perfil activo del usuario
                if (user.activeProfile.type === 'admin') {
                    roleBasedNavigation = cloneDeep(this._adminNavigation);
                } else if (user.activeProfile.type === 'student') {
                    roleBasedNavigation = cloneDeep(this._studentNavigation);
                } else {
                    // Perfil desconocido, usar navegación predeterminada
                    roleBasedNavigation = cloneDeep(this._defaultNavigation);
                }
            } else {
                // Si no hay usuario o perfil activo, usar navegación predeterminada
                roleBasedNavigation = cloneDeep(this._defaultNavigation);
            }

            // Fill compact navigation children using the role-based navigation
            this._compactNavigation.forEach((compactNavItem) => {
                roleBasedNavigation.forEach((navItem) => {
                    if (navItem.id === compactNavItem.id) {
                        compactNavItem.children = cloneDeep(
                            navItem.children
                        );
                    }
                });
            });

            // Fill futuristic navigation children using the role-based navigation
            this._futuristicNavigation.forEach((futuristicNavItem) => {
                roleBasedNavigation.forEach((navItem) => {
                    if (navItem.id === futuristicNavItem.id) {
                        futuristicNavItem.children = cloneDeep(
                            navItem.children
                        );
                    }
                });
            });

            // Fill horizontal navigation children using the role-based navigation
            this._horizontalNavigation.forEach((horizontalNavItem) => {
                roleBasedNavigation.forEach((navItem) => {
                    if (navItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            navItem.children
                        );
                    }
                });
            });

            // Return the response
            return [
                200,
                {
                    // compact: cloneDeep(this._compactNavigation),
                    default: cloneDeep(roleBasedNavigation),
                    // futuristic: cloneDeep(this._futuristicNavigation),
                    // horizontal: cloneDeep(this._horizontalNavigation),
                },
            ];
        });
    }
}
